var render = function render() {
    var _vm = this,
        _c = _vm._self._c;return _vm.editResourceDialog.visible ? _c('div', { ref: "popup", staticClass: "edit-resource-popup", style: {
            top: _vm.currentPopupTop
        }, on: { "click": function click($event) {
                $event.stopPropagation();return function () {}.apply(null, arguments);
            } } }, [_c('div', { staticClass: "edit-resource-popup-title" }, [_c('span', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('a', { staticClass: "el-icon-close close-edit-resource-dialog", on: { "click": function click($event) {
                $event.stopPropagation();$event.preventDefault();return _vm.closeEditResourceDialog.apply(null, arguments);
            } } })]), _vm._v(" "), _c('div', { staticClass: "edit-resource-popup-body" }, [_vm.currentResource && _vm.currentCategory ? _c('edit-resource', { attrs: { "resource": _vm.currentResource, "category": _vm.currentCategory, "meta-data": _vm.fileMetaData } }) : _vm._e()], 1)]) : _vm._e();
};
var staticRenderFns = [];

export { render, staticRenderFns };